'use strict';

var ngModule = 'frontend.filters';

require('angular')
  .module(ngModule, [ require('angular-sanitize') ])
  .filter('trustUrl', require('./trustUrl'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/filters/index.js
 ** module id = 25
 ** module chunks = 0
 **/